import React, { useCallback, useState } from "react";
import GlobalFeedback from "../../../global/GlobalFeedback";
import GlobalSuccessFlashModal from "../../../global/GlobalSuccessFlashModal";
import GlobalQuickJump from "../../../global/GlobalQuickJump";
import AttendanceLocationsSection from "../components/control/sections/AttendanceLocationsSection";
import AttendanceHolidaysSection from "../components/control/sections/AttendanceHolidaysSection";
import AttendanceSickLeavesSection from "../components/control/sections/AttendanceSickLeavesSection";
import AttendanceShiftsSection from "../components/control/sections/AttendanceShiftsSection";
import "../../user-builder/styles/userBuilder.css";
import "../../user-builder/styles/UserBuilderPage.css";
import "../styles/attendance.css";

const QUICK_JUMP_ITEMS = [
  { key: "locations", label: "Premises", targetId: "att-locations" },
  { key: "shifts", label: "Shifts", targetId: "att-shifts" },
  { key: "holidays", label: "Holidays", targetId: "att-holidays" },
  { key: "sick-leaves", label: "Sick leaves", targetId: "att-sick-leaves" },
];

const DEFAULT_SECTION = "locations";

export default function AttendanceControlPage() {
  const [activeSection, setActiveSection] = useState(DEFAULT_SECTION);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const onNotify = useCallback((message, { variant = "success" } = {}) => {
    const text = String(message ?? "").trim();
    if (!text) return;
    if (variant === "error") {
      setErrorMsg(text);
      setSuccessMsg("");
    } else {
      setSuccessMsg(text);
      setErrorMsg("");
    }
  }, []);

  return (
    <div className="user-builder-shell att-shell">
      <GlobalSuccessFlashModal message={successMsg} onDismiss={() => setSuccessMsg("")} />
      <GlobalFeedback type="error" text={errorMsg} />

      <div className="user-builder-layout">
        <div className="user-builder-layout__main">
          {activeSection === "locations" ? (
            <AttendanceLocationsSection onNotify={onNotify} />
          ) : null}
          {activeSection === "holidays" ? (
            <AttendanceHolidaysSection onNotify={onNotify} />
          ) : null}
          {activeSection === "shifts" ? (
            <AttendanceShiftsSection onNotify={onNotify} />
          ) : null}
          {activeSection === "sick-leaves" ? (
            <AttendanceSickLeavesSection onNotify={onNotify} />
          ) : null}
        </div>

        <GlobalQuickJump
          asideAriaLabel="Attendance settings sections"
          items={QUICK_JUMP_ITEMS}
          activeKey={activeSection}
          onActiveChange={setActiveSection}
          scrollToTarget={false}
        />
      </div>
    </div>
  );
}
